// tokens.js — paleta y tamaños globales
export const T = {
  // Colores
  obs:       "#0A0C0E",
  tep:       "#111318",
  copal:     "#C8A96E",
  jade:      "#3D7068",
  turquesa:  "#4A8FA8",
  amaranto:  "#8B3A52",
  nixtamal:  "#EDEBE6",
  muted:     "rgba(237,235,230,0.22)",
  mutedLow:  "rgba(237,235,230,0.08)",
  cen:       "rgba(237,235,230,0.05)",

  // Tamaños de widget
  W_SM: { w: 180, h: 180 },
  W_MD: { w: 240, h: 240 },

  // Fuentes
  serif:  "'Cormorant Garamond', serif",
  sans:   "'Inter', sans-serif",
  mono:   "'JetBrains Mono', monospace",
};